import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography
} from '@mui/material';
import Button from './Button';
import FormGroup from './FormGroup';
import Alert from './Alert';
import api from '../services/api';

function DeleteRuleDialog({ isOpen, onClose, onRuleDeleted, rule }) {
  const [reason, setReason] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);

    try {
      const deleteData = {
        reason: reason
        // deactivated_by is now auto-filled from authenticated session
      };

      await api.deleteRule(rule.id, deleteData);
      onRuleDeleted();
    } catch (err) {
      setError(err.message);
      setSubmitting(false);
    }
  };

  return (
    <Dialog 
      open={isOpen} 
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Delete Rule</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          {error && <Alert variant="error">{error}</Alert>}
          
          <Typography variant="body1" className="mb-4" color="text.secondary">
            Are you sure you want to delete this rule?
          </Typography>
          
          <Typography 
            variant="body2" 
            className="p-3 bg-gray-100 rounded mb-4"
            sx={{ fontStyle: 'italic', color: '#1f2937' }}
          >
            "{rule?.rule_text}"
          </Typography>

          <FormGroup label="Reason for Deletion" required>
            <TextField
              multiline
              rows={3}
              fullWidth
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Enter reason for deleting this rule..."
              required
            />
          </FormGroup>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button variant="outlined" onClick={onClose} disabled={submitting}>
            Cancel
          </Button>
          <Button 
            type="submit" 
            disabled={submitting}
            sx={{
              backgroundColor: '#ef4444',
              '&:hover': {
                backgroundColor: '#dc2626'
              }
            }}
          >
            {submitting ? 'Deleting...' : 'Delete Rule'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}

export default DeleteRuleDialog;

